import Env from "../utils/env";
import { ISubscriptionPartnerInfo } from "../interfaces/subscriptions";
import { getUri } from "../utils/fetch";
import { IProjectChecklistResponse } from "../interfaces/projectChecklist";

export const getPartnerInfo = (signal: AbortSignal):  Promise<ISubscriptionPartnerInfo> => {
  const uri = Env.pfsAPIUrl.clone()
    .setPath(`${Env.pfsApiPrefix}/ps/partners/current`);
  return getUri(uri, {
    signal
  });
}
export const getProjectChecklist = (projectId: string, signal: AbortSignal):  Promise<IProjectChecklistResponse> => {
  const uri = Env.pfsAPIUrl.clone()
    .setPath(`${Env.pfsApiPrefix}/cs/projects/id/${projectId}/checklist/status`);
  return getUri(uri, {
    signal
  });
}
